var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.sType,_vm._b({tag:"component",staticClass:"link-btn",on:{"click":function($event){return _vm.$emit('click', $event)}}},'component',_vm.obAttrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }